var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"p-2"},[_c('p',{staticClass:" text-yellow-700 text xs text-center mb-1"},[_vm._v(" Versión: "+_vm._s(_vm.version)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }